/* ============================================================
   AVORA ABOUT — Proof cards: count-up with comma formatting,
   staggered card reveal, star pop-in
   ============================================================ */

(function () {
  var grid = document.getElementById('avora-about-proof');
  if (!grid) return;

  function animateCount(el) {
    var target = parseFloat(el.dataset.countTarget);
    var isDecimal = el.dataset.countDecimal === 'true';
    var useComma = el.dataset.countComma === 'true';
    var duration = 1800;
    var start = performance.now();

    function update(now) {
      var elapsed = now - start;
      var progress = Math.min(elapsed / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = eased * target;

      if (isDecimal) {
        el.textContent = current.toFixed(1);
      } else {
        var rounded = Math.floor(current);
        el.textContent = useComma ? rounded.toLocaleString() : rounded;
      }

      if (progress < 1) requestAnimationFrame(update);
    }

    requestAnimationFrame(update);
  }

  /* Reduced motion — show final state immediately */
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    grid.classList.add('is-visible');
    grid.querySelectorAll('.avora-about__proof-num').forEach(function (el) {
      var target = parseFloat(el.dataset.countTarget);
      var isDecimal = el.dataset.countDecimal === 'true';
      var useComma = el.dataset.countComma === 'true';
      if (isDecimal) {
        el.textContent = target.toFixed(1);
      } else {
        el.textContent = useComma ? Math.floor(target).toLocaleString() : Math.floor(target);
      }
    });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        grid.classList.add('is-visible');
        grid.querySelectorAll('.avora-about__proof-num').forEach(function (num) {
          animateCount(num);
        });
        observer.unobserve(grid);
      }
    });
  }, { threshold: 0.3 });

  observer.observe(grid);
})();
